import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import "./LegalPage.css";

function CookiePolicy() {
  const { locale } = useI18n();

  if (locale === "pl") {
    return (
      <div className="legal-page">
        <div className="legal-card">
          <Link to="/" className="legal-back-link">
            ← Powrót do strony głównej
          </Link>

          <h1>Polityka plików cookie</h1>
          <p className="legal-version">
            Ostatnia aktualizacja: 10 września 2026 r.
          </p>

          <section>
            <p>
              Niniejsza Polityka plików cookie wyjaśnia, czym są pliki cookie
              i w jaki sposób ich używamy. Opisuje również rodzaje używanych
              plików cookie, informacje zbierane za ich pomocą oraz sposób ich
              wykorzystywania.
            </p>
            <p>
              Pliki cookie zazwyczaj nie zawierają informacji bezpośrednio
              identyfikujących użytkownika. Mogą jednak być powiązane z
              przechowywanymi przez nas danymi osobowymi. Więcej informacji o
              ochronie danych znajduje się w{" "}
              <Link to="/privacy">Polityce prywatności</Link>.
            </p>
            <p>
              Nie przechowujemy w używanych przez nas plikach cookie
              szczególnie wrażliwych danych osobowych, takich jak adres
              korespondencyjny lub hasło do konta.
            </p>
          </section>

          <section>
            <h2>Interpretacja i definicje</h2>
            <h3>Interpretacja</h3>
            <p>
              Słowa pisane wielką literą mają znaczenie określone w poniższych
              definicjach, niezależnie od tego, czy występują w liczbie
              pojedynczej, czy mnogiej.
            </p>
            <h3>Definicje</h3>
            <p>Na potrzeby niniejszej Polityki plików cookie:</p>
            <ul>
              <li>
                <strong>Firma</strong> oznacza SPARKY SIMPLE JOINT-STOCK
                COMPANY, ul. Aleje Jerozolimskie 109, 02-011 Warszawa.
              </li>
              <li>
                <strong>Pliki cookie</strong> to małe pliki umieszczane przez
                stronę internetową na komputerze, urządzeniu mobilnym lub
                innym urządzeniu użytkownika.
              </li>
              <li>
                <strong>Strona internetowa</strong> oznacza TajneMysli,
                dostępną pod adresem{" "}
                <a href="https://tajnemysli.com" target="_blank" rel="external nofollow noopener">
                  tajnemysli.com
                </a>
                .
              </li>
              <li>
                <strong>Użytkownik</strong> oznacza osobę korzystającą ze
                strony internetowej.
              </li>
            </ul>
          </section>

          <section>
            <h2>Wykorzystywanie plików cookie</h2>
            <h3>Rodzaje używanych plików cookie</h3>
            <p>
              Pliki cookie mogą być sesyjne lub trwałe. Pliki sesyjne są
              usuwane po zamknięciu przeglądarki, natomiast pliki trwałe
              pozostają na urządzeniu użytkownika po zakończeniu sesji.
            </p>
            <p>
              Jeśli wymagają tego przepisy prawa, przed użyciem plików cookie,
              które nie są niezbędne, poprosimy o zgodę. Niezbędne pliki cookie
              służą do prawidłowego działania strony i nie można ich wyłączyć
              w naszych systemach.
            </p>
            <ul>
              <li>
                <strong>Niezbędne pliki cookie</strong> — sesyjne pliki używane
                do uwierzytelniania użytkowników i ochrony kont przed
                nieuprawnionym użyciem.
              </li>
              <li>
                <strong>Funkcjonalne pliki cookie</strong> — trwałe pliki,
                które zapamiętują wybory użytkownika, takie jak dane logowania
                lub preferencje językowe.
              </li>
            </ul>

            <h3>Wybór użytkownika</h3>
            <p>
              Użytkownik może wyłączyć pliki cookie w ustawieniach przeglądarki
              i usunąć zapisane pliki cookie. Odrzucenie plików cookie może
              spowodować, że niektóre funkcje strony nie będą działać
              prawidłowo.
            </p>
            <p>
              Instrukcje dotyczące usuwania plików cookie znajdują się na
              oficjalnych stronach pomocy używanej przeglądarki.
            </p>
          </section>

          <section>
            <h3>Zmiany w Polityce plików cookie</h3>
            <p>
              Możemy okresowo aktualizować niniejszą Politykę plików cookie.
              Data aktualizacji na początku dokumentu wskazuje, kiedy
              wprowadzono ostatnie zmiany.
            </p>
          </section>

          <section>
            <h3>Kontakt</h3>
            <p>
              W przypadku pytań dotyczących tej Polityki plików cookie
              skontaktuj się z nami pod adresem{" "}
              <a href="mailto:help@tajnemysli.com">help@tajnemysli.com</a>.
            </p>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/" className="legal-back-link">
          ← Back to home
        </Link>

        <h1>Cookies Policy</h1>

        <p className="legal-version">
          Last updated: September 10, 2026
        </p>

        <section>
          <p>
            This Cookies Policy explains what Cookies are and how We use
            them. You should read this policy so You can understand what
            type of cookies We use, or the information We collect using
            Cookies and how that information is used.
          </p>

          <p>
            Cookies do not typically contain any information that
            personally identifies a user, but personal information that We
            store about You may be linked to the information stored in and
            obtained from Cookies. For further information on how We use,
            store and keep your personal data secure, see our{" "}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>

          <p>
            We do not store sensitive personal information, such as mailing
            addresses, account passwords, etc. in the Cookies We use.
          </p>
        </section>

        <section>
          <h2>Interpretation and Definitions</h2>

          <h3>Interpretation</h3>
          <p>
            The words whose initial letters are capitalized have meanings
            defined under the following conditions. The following
            definitions shall have the same meaning regardless of whether
            they appear in singular or in plural.
          </p>

          <h3>Definitions</h3>
          <p>For the purposes of this Cookies Policy:</p>
          <ul>
            <li>
              <strong>Company</strong> (referred to as either "the Company",
              "We", "Us" or "Our" in this Cookies Policy) refers to SPARKY
              SIMPLE JOINT-STOCK COMPANY, ul. Aleje Jerozolimskie 109 02-011
              Warsaw.
            </li>
            <li>
              <strong>Cookies</strong> means small files that are placed on
              Your computer, mobile device or any other device by a
              website, containing details of your browsing history on that
              website among its many uses.
            </li>
            <li>
              <strong>Website</strong> refers to TajneMysli, accessible from{" "}
              <a
                href="https://tajnemysli.com"
                rel="external nofollow noopener"
                target="_blank"
              >
                tajnemysli.com
              </a>
              .
            </li>
            <li>
              <strong>You</strong> means the individual accessing or using
              the Website, or a company, or any legal entity on behalf of
              which such individual is accessing or using the Website, as
              applicable.
            </li>
          </ul>
        </section>

        <section>
          <h2>The use of the Cookies</h2>

          <h3>Type of Cookies We Use</h3>
          <p>
            Cookies can be "Persistent" or "Session" Cookies. Persistent
            Cookies remain on your personal computer or mobile device when
            You go offline, while Session Cookies are deleted as soon as You
            close your web browser.
          </p>

          <p>
            Where required by law, We will request your consent before
            using Cookies that are not strictly necessary. Strictly
            necessary Cookies are used to provide the Website and cannot be
            switched off in our systems.
          </p>

          <p>
            We use both session and persistent Cookies for the purposes set
            out below:
          </p>

          <ul>
            <li>
              <p><strong>Necessary / Essential Cookies</strong></p>
              <p>Type: Session Cookies</p>
              <p>Administered by: Us</p>
              <p>
                Purpose: These Cookies are essential to provide You with
                services available through the Website and to enable You to
                use some of its features. They help to authenticate users
                and prevent fraudulent use of user accounts. Without these
                Cookies, the services that You have asked for cannot be
                provided, and We only use these Cookies to provide You with
                those services.
              </p>
            </li>
            <li>
              <p><strong>Functionality Cookies</strong></p>
              <p>Type: Persistent Cookies</p>
              <p>Administered by: Us</p>
              <p>
                Purpose: These Cookies allow Us to remember choices You make
                when You use the Website, such as remembering your login
                details or language preference. The purpose of these
                Cookies is to provide You with a more personal experience
                and to avoid You having to re-enter your preferences every
                time You use the Website.
              </p>
            </li>
          </ul>

          <h3>Your Choices Regarding Cookies</h3>
          <p>
            If You prefer to avoid the use of Cookies on the Website, first
            You must disable the use of Cookies in your browser and then
            delete the Cookies saved in your browser associated with the
            Website. You may use this option for preventing the use of
            Cookies at any time.
          </p>

          <p>
            If You do not accept Our Cookies, You may experience some
            inconvenience in your use of the Website and some features may
            not function properly.
          </p>

          <p>
            If You'd like to delete Cookies or instruct your web browser to
            delete or refuse Cookies, please visit the help pages of your
            web browser.
          </p>

          <ul>
            <li>
              For the Chrome web browser, please visit this page from
              Google:{" "}
              <a
                href="https://support.google.com/accounts/answer/32050"
                rel="external nofollow noopener"
                target="_blank"
              >
                https://support.google.com/accounts/answer/32050
              </a>
            </li>
            <li>
              For the Microsoft Edge browser, please visit this page from
              Microsoft:{" "}
              <a
                href="https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                rel="external nofollow noopener"
                target="_blank"
              >
                https://support.microsoft.com/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09
              </a>
            </li>
            <li>
              For the Firefox web browser, please visit this page from
              Mozilla:{" "}
              <a
                href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored"
                rel="external nofollow noopener"
                target="_blank"
              >
                https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored
              </a>
            </li>
            <li>
              For the Safari web browser, please visit this page from Apple:{" "}
              <a
                href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                rel="external nofollow noopener"
                target="_blank"
              >
                https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac
              </a>
            </li>
          </ul>

          <p>
            For any other web browser, please visit your web browser's
            official web pages.
          </p>
        </section>

        <section>
          <h3>Changes to this Cookies Policy</h3>
          <p>
            We may update this Cookies Policy from time to time. The "Last
            updated" date at the top indicates when it was last revised.
          </p>
        </section>

        <section>
          <h3>Contact Us</h3>
          <p>
            If you have any questions about this Cookies Policy, You can
            contact us:
          </p>
          <ul>
            <li>
              By email:{" "}
              <a href="mailto:help@tajnemysli.com">help@tajnemysli.com</a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default CookiePolicy;
